import { Divider, Grid, Slide } from '@mui/material';
import { HSpacer, RoutalPalette } from '@nx-smartmonkey/ui';

import { createPortal } from 'react-dom';
import BackArrowIcon from '../assets/svg/BackArrowIcon';

interface SlidingMenuWithBackProps {
  id: string;
  isOpen: boolean;
  onClose: (...args: any[]) => any;
  headerContent?: React.ReactNode;
  headerStyles?: React.CSSProperties;
  footerContent?: React.ReactNode;
  direction?: `left` | `right` | `up` | `down`;
  background?: string;
  slideStyles?: React.CSSProperties;
  childrenContainerStyles?: React.CSSProperties;
  portalElementId?: string;
}

export const SlidingMenuWithBack = ({
  id,
  isOpen,
  onClose,
  headerContent,
  headerStyles,
  footerContent,
  children,
  direction = `left`,
  background,
  slideStyles = {},
  childrenContainerStyles = {},
  portalElementId,
}: React.PropsWithChildren<SlidingMenuWithBackProps>) => {
  if (!isOpen) return null;

  const content = (
    <Slide
      key={id}
      in
      direction={direction}
      mountOnEnter
      unmountOnExit
      timeout={{ enter: 400, exit: 300 }}
      style={{ zIndex: 1006, position: `absolute`, top: 0, ...slideStyles }}
    >
      <Grid
        style={{
          height: `100%`,
          width: `100%`,
          overflowY: `hidden`,
          background,
        }}
      >
        <Grid
          container
          wrap="nowrap"
          direction="column"
          style={{
            height: `100%`,
          }}
        >
          <Grid
            container
            direction="row"
            wrap="nowrap"
            alignItems="center"
            style={{
              padding: `0 20px`,
              background,
              ...headerStyles,
            }}
          >
            <BackArrowIcon
              style={{
                color: RoutalPalette.secondary40,
                height: `28px`,
                width: `28px`,
                fontSize: `25px`,
                cursor: `pointer`,
              }}
              onClick={() => onClose()}
            />
            <HSpacer small />
            {headerContent}
          </Grid>

          <Divider style={{ backgroundColor: RoutalPalette.neutral10 }} />

          <Grid
            container
            direction="column"
            style={{
              padding: `20px`,
              flex: 1,
              background,
              ...childrenContainerStyles,
            }}
          >
            {children}
          </Grid>

          {footerContent}
        </Grid>
      </Grid>
    </Slide>
  );

  const element = document.getElementById(portalElementId ?? ``);
  if (element) {
    return createPortal(content, element as HTMLElement);
  }

  return content;
};
